import React, { useMemo, useState } from "react";
import { Popover } from "@mui/material";
import { PieceWithCoords } from "../../types/game";
import { theme } from "../../style/theme";
import { icons } from "../../style/icons";
import { useApp } from "../../contexts/app";
import {
  hexRenderPosition,
  hexPolygonPoints,
  sideLength,
  hexratio,
  paddingViewport,
  iconsSizeReduction,
} from "../../game/geometry";

export const BoardPiece = ({
  piece,
  transform,
  clickable,
}: {
  piece: PieceWithCoords;
  transform: {
    scale: number;
    min: { x: number; y: number };
    offsetInDiv: { X: number; Y: number };
  };
  clickable: boolean;
}) => {
  const {
    state: { game },
    dispatch,
  } = useApp();

  const isMobile = useMemo(
    () =>
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ),
    []
  );

  const [anchorEl, setAnchorEl] = useState<SVGPolygonElement | null>(null);

  const handleOpen = (event: React.MouseEvent<SVGPolygonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const [mousePos, setMousePos] = useState({ top: 0, left: 0 });

  const open = Boolean(anchorEl);

  const { width, height, top, left } = hexRenderPosition({
    coords: piece.cartesian,
    h: piece.h,
    transform,
  });

  const hside = hexratio;
  const vside = sideLength;
  const p = paddingViewport;

  const isOwnedByCurrentPlayer = piece.owner.id === game.turnOfPlayer.id;
  const canBeMoved = useMemo(
    () => clickable && game.board.canBeMoved(piece) && isOwnedByCurrentPlayer,
    [clickable, game.board, isOwnedByCurrentPlayer, piece]
  );

  const handleClick = (e: React.MouseEvent<SVGPolygonElement, MouseEvent>) => {
    console.log("clicked on BoardPiece");

    console.log("canBeMoved?", canBeMoved);
    if (canBeMoved) {
      e.stopPropagation();
      dispatch({
        type: "SET_SELECTED_PIECE_TO_MOVE",
        payload: { piece },
      });
    }
  };

  const handleMouseEnter = clickable
    ? (e: React.MouseEvent<SVGPolygonElement, MouseEvent>) => {
        if (game.board.getHeightAt(piece.hex) !== piece.h) {
          // setMousePos({ left: e.pageX, top: e.pageY });
          handleOpen(e);
        }
        if (canBeMoved) {
          dispatch({
            type: "SET_MOVE_PREVIEW",
            payload: { piece },
          });
        }
      }
    : () => {};

  const handleMouseLeave = clickable
    ? () => {
        handleClose();
        if (canBeMoved) {
          dispatch({
            type: "SET_MOVE_PREVIEW",
            payload: { piece: null },
          });
        }
      }
    : () => {};

  return (
    <>
      <div
        className="pointer-events-none"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          left,
          top,
          position: "absolute",
        }}
      >
        <svg
          className="pointer-events-none"
          width="100%"
          height="100%"
          viewBox={`${-hside - p} ${-vside - p} ${2 * (hside + p)} ${
            2 * (vside + p)
          }`}
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <polygon
            className={`pointer-events-all ${
              game.action.moving?.valueOf() === piece.valueOf()
                ? "shadow-piece"
                : ""
            } ${canBeMoved ? "can-be-moved" : ""} ${
              theme.board.piece.fillClass[piece.owner.id]
            }`}
            points={hexPolygonPoints}
            // fill={theme.board.piece.fill[piece.owner.id]}
            stroke="#8D8C92"
            strokeWidth={theme.board.piece.stroke.width}
            // onTouchStart={handleClick}
            onClick={handleClick}
            {...(isMobile
              ? {}
              : {
                  onMouseEnter: handleMouseEnter,
                  onMouseLeave: handleMouseLeave,
                })}
          />
        </svg>
      </div>

      <Popover
        open={open}
        // anchorEl={anchorEl}
        // anchorPosition={{ left: mousePos.left, top: mousePos.top }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        style={{ pointerEvents: "none" }}
        disableRestoreFocus
      >
        <img
          className="m-2"
          src={icons.classic[piece.kind]}
          alt={piece.kind}
          style={{
            width: "80px", // TODO: responsive
            height: "80px",
          }}
        />
      </Popover>

      <img
        src={icons.classic[piece.kind]}
        alt={piece.kind}
        style={{
          width: `${width * iconsSizeReduction}px`,
          height: `${height * iconsSizeReduction}px`,
          left: left + (width * (1 - iconsSizeReduction)) / 2,
          top: top + (height * (1 - iconsSizeReduction)) / 2,
          position: "absolute",
          // cursor: "pointer",
          pointerEvents: "none",
        }}
      />
    </>
  );
};
